import {
  Box,
  CardContent,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import * as React from "react";
import reactStringReplace from "react-string-replace";
import QuestionDescription from "./QuestionDescription";

const QuestionFillGapsSolution = ({ question }) => {
  const optionMenuItems = question["options"].map((option) => (
    <MenuItem value={option}>{option}</MenuItem>
  ));

  const selects = reactStringReplace(
    question["text_hidden"],
    "${}",
    (match, idx) => (
      <FormControl size="small">
        <Select
          variant="standard"
          disabled
          value={question["options"][(idx - 1) / 2]}
        >
          {optionMenuItems}
        </Select>
      </FormControl>
    )
  );

  const selectsLineBroken = selects.map((el) => {
    return typeof el === "string"
      ? reactStringReplace(el, /\\n|\n/g, () => <br />)
      : el;
  });

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Grid item>
        <Paper elevation={10} sx={{ m: 1, maxWidth: 1000 }}>
          <CardContent>
            <QuestionDescription description={question["description"]} />
            <Box>{selectsLineBroken}</Box>
          </CardContent>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default QuestionFillGapsSolution;
